import {useQuery} from "@tanstack/react-query";
import {type GetRafflesParams, getRafflesService} from "./raffles.service";
import type {Raffle} from "./raffles.types";

export const RAFFLES_QUERY_KEY = "raffles" as const;

export const useRaffles = (params: GetRafflesParams = {}) => {
  const query = useQuery<Raffle[], Error>({
    queryKey: [RAFFLES_QUERY_KEY, params.page ?? 1, params.pageSize ?? 20],
    queryFn: () => getRafflesService(params),
    staleTime: 60_000,
  });
  return {
    raffles: query.data ?? [],
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error,
    refetch: query.refetch,
  };
};
